export default __webpack_public_path__ + "static/media/producthistoryreport.067e3ceb.txt";